// extracted by mini-css-extract-plugin
module.exports = {"pi_creature":"PiCreature_pi_creature__epuwV","frame":"PiCreature_frame__PZqKS","text":"PiCreature_text__m1Fw6","fade_in":"PiCreature_fade_in__ajeG6"};